import { InfoButton } from 'src/components/PageLayout/InfoButton'
import styled from 'styled-components/macro'

export const ShowLatestInfoButton = styled(InfoButton)`
  margin-right: 12px;
`
